export default "__VITE_ASSET__e0897810__"